import styled from 'styled-components';
// import TopList from './components/TopList';
import GeneraliSupportList from './components/GeneraliSupportList';
import { Row, Col } from 'antd';
import './SupportPageStyle.less';
import { useTranslation } from 'react-i18next';
import GreetingSection from '../../components/navbar/GreetingSection';

const SupportPageContainer = styled.div`
  margin: 0;
  dispay: flex;
`;
// const Row = styled(AntdRow)`
//   margin-bottom: 2.5rem;
// `;

function SupportPage() {
  const { t } = useTranslation();
  return (
    <SupportPageContainer
      style={{
        position: 'relative',
      }}
      className="Support"
    >
      <GreetingSection pageName={t('life.support.title')} showicon={true} />
      <Row gutter={[{ xs: 8, sm: 24, lg: 24 }, 16]} wrap className="listRow">
        <Col xs={{ span: 24 }} sm={{ span: 23, offset: 1 }} lg={{ span: 15, offset: 6 }}>
          <GeneraliSupportList></GeneraliSupportList>
        </Col>
        {/* <Col xs={{ span: 24 }} sm={{ span: 23, offset: 1 }} lg={{ span: 12, offset: 0 }}>
          <TopList></TopList>
        </Col> */}
      </Row>
    </SupportPageContainer>
  );
}

export default SupportPage;
